// Action Creators
// Logic Modules
import { LogicModule } from "@ms/planner-logicmodules/lib/local/modules/LogicModule";
/**
 * Performs Actions related to view lifeycle like data fetch and force data fetch
 */ export class ViewLifecycleActionCreator {
    viewDataFetch(viewDetails, state) {
        this.modules.load(LogicModule.ViewLifecycle).setViewDataFetchState(viewDetails, state);
    }
    viewForceFetch(viewDetails, shouldForceFetch) {
        this.modules.load(LogicModule.ViewLifecycle).setViewForceFetchDataState(viewDetails, shouldForceFetch);
    }
    /**
     * Initializes a new instance of the performance collector action creator
     * @param modules The logic module providers the SPA uses to get logic modules
     */ constructor(modules){
        this.modules = modules;
    }
}
